import React from "react";
import IntegracaoIaService from "../../services/IntegracaoIaService";
import Permissao from "../../controllers/Permissao";
import BtnButton from "../../components/forms/elements/BtnButton";
import Util from "../../utils/Util";
import { toast } from "react-toastify";
import "./IntegracoesIA.css";

const AJUDA = {
    chatgpt: "https://platform.openai.com/docs/guides/tools-remote-mcp",
    claude: "https://support.claude.com/en/articles/11175166-get-started-with-custom-connectors-using-remote-mcp",
    claudeCode: "https://code.claude.com/docs/en/mcp",
    codex: "https://developers.openai.com/codex/mcp",
    cursor: "https://cursor.com/docs/context/mcp",
};

const ROTULO_CURTO = {
    financeiro: "Financeiro",
    vendas: "Vendas",
    comercial: "Comercial",
    paineis: "Painéis",
    clientes: "Clientes",
    analise: "Análise SQL",
};

function quando(valor) {
    if (!valor) return "—";
    const data = new Date(String(valor).replace(" ", "T"));
    if (Number.isNaN(data.getTime())) return valor;
    return data.toLocaleString("pt-BR");
}

function rotuloPacote(codigo) {
    return ROTULO_CURTO[codigo] || codigo;
}

const REGRAS = `Regras:
- Use só as ferramentas do conector BDM. Não invente número. Se um pacote não estiver autorizado, omita a seção e avise.
- Faturado é a soma das parcelas não estornadas pela data da fatura, igual ao painel Faturado por Mês. Não some vlFatura.
- Recebido é a baixa não estornada pela data da baixa, igual a Baixa por Mês.
- À vencer e vencidas são o estoque de hoje. O em_aberto da série é só o saldo das faturas emitidas naquele mês.
- Ordem cancelada é idOrdemStatus 3. Série e margem já excluem. No resumo, mostre Cancelado separado.
- Não mostre CPF, CNPJ, telefone, e-mail, placa ou chassi.
- Valores em reais.`;

const PROMPTS = [
    {
        id: "dashboard",
        label: "Dashboard completo",
        texto: "Um painel interativo com financeiro, vendas, comercial e os blocos do sistema.",
        prompt: `Monte um dashboard interativo da BDM Performance com tudo o que o conector permitir nesta sessão.

${REGRAS}

Período: ano corrente até hoje, com visão por mês e seletor de ano. Ao tocar num mês, detalhe aquele mês.

Inclua, quando a ferramenta existir:
1. Financeiro: resumo_financeiro, serie_faturamento_recebimento, contas_a_receber, previsao_recebimento, recebimentos_por_forma, inadimplencia_por_oficina, notas_fiscais_resumo.
2. Vendas: resumo_ordens, serie_ordens, ranking_oficinas, margem, produtos_mais_vendidos, estoque_critico.
3. Comercial: funil_contatos e serie_contatos.
4. Painéis: listar_paineis e executar_bloco nos blocos de à faturar, à vencer, vencidas, baixa no mês, baixa por mês, vencimento por mês e faturado por mês.
5. Clientes, só se o pacote estiver ligado: maiores_devedores.

Entregue cartões no topo, gráficos de série e tabelas.`,
    },
    {
        id: "financeiro",
        label: "Financeiro",
        texto: "Faturado, recebido e contas a receber no mesmo critério do dashboard.",
        prompt: `Faça o relatório financeiro da BDM no ano corrente até hoje, por mês, com detalhe do mês ao toque.

${REGRAS}

Use resumo_financeiro, serie_faturamento_recebimento, contas_a_receber, recebimentos_por_forma, previsao_recebimento, inadimplencia_por_oficina e notas_fiscais_resumo.

Mostre faturado, recebido, descontos, encargos, à vencer, vencidas e o aging. Compare o mês atual com o mês anterior.`,
    },
    {
        id: "vendas",
        label: "Vendas",
        texto: "Ordens, ranking, margem, produtos e estoque.",
        prompt: `Analise as vendas da BDM no ano corrente até hoje.

${REGRAS}

Use resumo_ordens, serie_ordens, ranking_oficinas, margem, produtos_mais_vendidos e estoque_critico.

Separe produto e serviço. No ranking, mostre quantidade e valor. No estoque, liste só o que está abaixo do mínimo, com o consumo recente.`,
    },
    {
        id: "comercial",
        label: "Comercial",
        texto: "Funil de contatos, origem e conversão.",
        prompt: `Monte o funil comercial da BDM no ano corrente até hoje, por mês.

${REGRAS}

Use funil_contatos e serie_contatos. Mostre origem, tipo, status, motivo, UTM, contatos válidos e taxa de conversão. Ao tocar num mês, detalhe a origem daquele mês.`,
    },
    {
        id: "paineis",
        label: "Painéis",
        texto: "Os mesmos blocos do dashboard do sistema.",
        prompt: `Reproduza os painéis do dashboard da BDM.

${REGRAS}

Chame listar_paineis e execute com executar_bloco os blocos de à faturar, à vencer, vencidas, baixa no mês atual, baixa por mês, vencimento por mês e faturado por mês. Use o ano corrente. Entregue os cartões e as tabelas com os mesmos títulos do sistema.`,
    },
    {
        id: "interativo",
        label: "Interativo",
        texto: "O aplicativo pergunta o período e o foco antes de consultar.",
        prompt: `Quero analisar a BDM com o conector. Antes de consultar, pergunte o período (mês, ano ou intervalo) e o foco: financeiro, vendas, comercial, estoque, inadimplência ou dashboard completo.

${REGRAS}

Só então chame as ferramentas desse foco. Entregue um resultado interativo: seletor de período e detalhe ao toque. Se eu pedir outro foco, reaproveite as regras e consulte de novo.`,
    },
];

export default class IntegracoesIA extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            config: null,
            conexoes: [],
            atividade: [],
            aceitoTermo: false,
            aba: "chatgpt",
            abaPrompt: "dashboard",
            erro: null,
        };
        this.carregar = this.carregar.bind(this);
        this.salvar = this.salvar.bind(this);
        this.revogar = this.revogar.bind(this);
        this.copiar = this.copiar.bind(this);
    }

    componentDidMount() {
        this.carregar();
    }

    carregar() {
        IntegracaoIaService.getIntegracao((cfg, err) => {
            if (cfg) this.setState({ config: cfg, erro: null });
            else if (err) this.setState({ erro: "Não foi possível carregar a configuração." });
        });
        IntegracaoIaService.getConexoes((c) => {
            if (Array.isArray(c)) this.setState({ conexoes: c });
        });
        IntegracaoIaService.getAtividade((a) => {
            if (Array.isArray(a)) this.setState({ atividade: a });
        });
    }

    copiar(texto) {
        if (Util.copyClipboard(texto)) {
            toast.success("Copiado para a área de transferência!");
        } else {
            toast.error("Erro ao copiar, copie manualmente.");
        }
    }

    salvar(parcial) {
        const cfg = { ...this.state.config, ...parcial };
        if (cfg.flAtiva && !cfg.dhTermoAceito && !this.state.aceitoTermo) {
            toast.error("Aceite o termo para ligar a integração.");
            return;
        }
        IntegracaoIaService.salvarIntegracao(
            {
                flAtiva: cfg.flAtiva ? 1 : 0,
                dsPacotes: cfg.dsPacotes,
                aceitoTermo: this.state.aceitoTermo ? 1 : 0,
            },
            (resp, err) => {
                if (err || !resp) {
                    toast.error("Erro ao salvar configuração.");
                    return;
                }
                toast.success(cfg.flAtiva ? "Integração ligada." : "Integração desligada.");
                this.setState({ config: resp });
            }
        );
    }

    revogar(uid) {
        if (!window.confirm("Revogar esta conexão? O aplicativo deixa de ler os dados na hora.")) return;
        IntegracaoIaService.revogar(uid, (resp, err) => {
            if (err) {
                toast.error("Não foi possível revogar a conexão.");
                return;
            }
            toast.success("Conexão revogada.");
            this.carregar();
        });
    }

    renderCopia(texto, ajuda) {
        return (
            <>
                <div className="ia-copy">
                    <code>{texto}</code>
                    <button type="button" className="btn btn-primary btn-sm flex-shrink-0" onClick={() => this.copiar(texto)}>
                        Copiar
                    </button>
                </div>
                {ajuda ? (
                    <a className="d-inline-block mt-2" href={ajuda} target="_blank" rel="noreferrer">Como conectar</a>
                ) : null}
            </>
        );
    }

    renderConectar(url, cmdClaudeCode, cmdCodex, cursorDeeplink, cursorMcpJson) {
        const abas = [
            {
                id: "chatgpt",
                label: "ChatGPT",
                texto: "Em Settings, Apps, crie um app com o nome BDM, cole o endereço e deixe o OAuth automático.",
                corpo: this.renderCopia(url, AJUDA.chatgpt),
            },
            {
                id: "claude",
                label: "Claude",
                texto: "Em Settings, Connectors, adicione um conector personalizado com este endereço.",
                corpo: this.renderCopia(url, AJUDA.claude),
            },
            {
                id: "claude-code",
                label: "Claude Code",
                texto: "Rode o comando e, no Claude Code, use /mcp para autenticar.",
                corpo: this.renderCopia(cmdClaudeCode, AJUDA.claudeCode),
            },
            {
                id: "codex",
                label: "Codex",
                texto: "Adicione o servidor e depois entre com codex mcp login bdm.",
                corpo: this.renderCopia(cmdCodex, AJUDA.codex),
            },
            {
                id: "cursor",
                label: "Cursor",
                texto: "Instale pelo link ou cole o trecho no mcp.json.",
                corpo: (
                    <>
                        <div className="d-flex flex-wrap gap-2 mb-3">
                            <a className="btn btn-sm btn-primary" href={cursorDeeplink}>Instalar no Cursor</a>
                            <a className="btn btn-sm btn-outline-primary" href={AJUDA.cursor} target="_blank" rel="noreferrer">Como conectar</a>
                        </div>
                        {this.renderCopia(cursorMcpJson)}
                    </>
                ),
            },
        ];
        const atual = abas.find((a) => a.id === this.state.aba) || abas[0];

        return (
            <div className="card h-100 mb-0">
                <div className="card-body">
                    <h2 className="h5 mb-1">Conectar aplicativo</h2>
                    <p className="text-muted">A autorização abre neste sistema. Nenhuma senha é copiada para o aplicativo.</p>
                    <div className="ia-pills mb-3" role="tablist">
                        {abas.map((aba) => (
                            <button
                                key={aba.id}
                                type="button"
                                role="tab"
                                aria-selected={atual.id === aba.id}
                                className={atual.id === aba.id ? "active" : ""}
                                onClick={() => this.setState({ aba: aba.id })}
                            >
                                {aba.label}
                            </button>
                        ))}
                    </div>
                    <p>{atual.texto}</p>
                    {atual.corpo}
                </div>
            </div>
        );
    }

    renderPrompts() {
        const atual = PROMPTS.find((p) => p.id === this.state.abaPrompt) || PROMPTS[0];

        return (
            <div className="card mb-4">
                <div className="card-body">
                    <h2 className="h5 mb-1">Prompts prontos</h2>
                    <p className="text-muted">Copie e cole no aplicativo conectado. O dashboard completo usa tudo o que a sua conexão permitir.</p>
                    <div className="ia-pills mb-3" role="tablist">
                        {PROMPTS.map((prompt) => (
                            <button
                                key={prompt.id}
                                type="button"
                                role="tab"
                                aria-selected={atual.id === prompt.id}
                                className={atual.id === prompt.id ? "active" : ""}
                                onClick={() => this.setState({ abaPrompt: prompt.id })}
                            >
                                {prompt.label}
                            </button>
                        ))}
                    </div>
                    <div className="d-flex justify-content-between align-items-start gap-3 mb-2">
                        <p className="mb-0">{atual.texto}</p>
                        <button type="button" className="btn btn-primary btn-sm flex-shrink-0" onClick={() => this.copiar(atual.prompt)}>
                            Copiar
                        </button>
                    </div>
                    <pre className="ia-pre">{atual.prompt}</pre>
                </div>
            </div>
        );
    }

    render() {
        const idConectar = this.state.config?.idModulosMcp?.conectar;
        if (idConectar && !Permissao.getInstance().getPermissao(idConectar)) {
            return <div className="alert alert-warning m-3">Sem permissão.</div>;
        }

        const cfg = this.state.config;
        const url = cfg?.mcpUrl || "https://mcp.bdmperformance.com.br";
        const podeConfig = cfg?.podeConfigurar;
        const cmdClaudeCode = `claude mcp add --transport http bdm ${url}`;
        const cmdCodex = `codex mcp add bdm --url ${url}`;
        const cursorDeeplink =
            "cursor://anysphere.cursor-deeplink/mcp/install?name=bdm&config=" +
            encodeURIComponent(window.btoa(JSON.stringify({ url })));
        const cursorMcpJson = JSON.stringify({ mcpServers: { bdm: { url } } }, null, 2);

        return (
            <div className="container-fluid py-3 ia-page">
                <h1 className="h4 mb-1">Integrações de IA</h1>
                <p className="text-muted mb-4">
                    O ChatGPT, o Claude, o Claude Code, o Codex e o Cursor leem os dados desta empresa. Cada autorização vale só para quem autorizou.
                </p>

                {this.state.erro && <div className="alert alert-danger">{this.state.erro}</div>}

                <div className="row g-3 mb-3">
                    <div className="col-lg-5">
                        <div className="card h-100">
                            <div className="card-body">
                                <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
                                    <div>
                                        <h2 className="h5 mb-1">O que podem ler</h2>
                                        <p className="text-muted mb-0 small">Quem configura escolhe os pacotes. A integração nasce desligada.</p>
                                    </div>
                                    {cfg && podeConfig ? (
                                        <div className="form-check form-switch mb-0">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="switch-mcp-ativa"
                                                checked={!!cfg.flAtiva}
                                                onChange={(e) => this.salvar({ flAtiva: e.target.checked ? 1 : 0, dsPacotes: cfg.dsPacotes })}
                                            />
                                            <label className="form-check-label" htmlFor="switch-mcp-ativa">
                                                {cfg.flAtiva ? "Ligada" : "Desligada"}
                                            </label>
                                        </div>
                                    ) : null}
                                </div>
                                {cfg && (podeConfig ? (
                                    <>
                                        {(cfg.pacotesDisponiveis || []).map((p) => (
                                            <div className="form-check mb-1" key={p.codigo}>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={"pkg-cfg-" + p.codigo}
                                                    checked={(cfg.dsPacotes || []).includes(p.codigo)}
                                                    onChange={() => {
                                                        const ds = cfg.dsPacotes || [];
                                                        const next = ds.includes(p.codigo)
                                                            ? ds.filter((c) => c !== p.codigo)
                                                            : [...ds, p.codigo];
                                                        this.salvar({ dsPacotes: next, flAtiva: cfg.flAtiva });
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor={"pkg-cfg-" + p.codigo}>
                                                    {p.rotulo}
                                                </label>
                                            </div>
                                        ))}
                                        {!cfg.dhTermoAceito && (
                                            <div className="form-check mt-3">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="check-termo-mcp"
                                                    checked={this.state.aceitoTermo}
                                                    onChange={(e) => this.setState({ aceitoTermo: e.target.checked })}
                                                />
                                                <label className="form-check-label" htmlFor="check-termo-mcp">
                                                    Aceito que os aplicativos autorizados leiam os dados dos pacotes escolhidos, só desta empresa.
                                                </label>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <p className="mb-0">{cfg.flAtiva ? "A integração está ligada nesta empresa." : "A integração está desligada. Só um administrador pode ligá-la."}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        {this.renderConectar(url, cmdClaudeCode, cmdCodex, cursorDeeplink, cursorMcpJson)}
                    </div>
                </div>

                {this.renderPrompts()}

                <div className="card mb-4">
                    <div className="card-body">
                        <h2 className="h5 mb-1">Conexões autorizadas</h2>
                        <p className="text-muted">{podeConfig ? "Todas as conexões desta empresa." : "Somente as suas conexões."}</p>
                        <div className="table-responsive">
                            <table className="table table-sm align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th>Aplicativo</th>
                                        <th>Pacotes</th>
                                        <th>Último uso</th>
                                        {podeConfig ? <th>Pessoa</th> : null}
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.conexoes.length === 0 ? (
                                        <tr>
                                            <td colSpan={podeConfig ? 5 : 4} className="text-muted">Nenhuma conexão autorizada.</td>
                                        </tr>
                                    ) : (
                                        this.state.conexoes.map((c) => (
                                            <tr key={c.uid}>
                                                <td>{c.rotulo || c.nmAplicativo}</td>
                                                <td>{(c.dsPacotes || []).map(rotuloPacote).join(", ") || "—"}</td>
                                                <td>{quando(c.dhUltimoUso)}</td>
                                                {podeConfig ? <td>{c.nomeUsuario || "—"}</td> : null}
                                                <td className="text-end">
                                                    {(c.minha || podeConfig) && (
                                                        <BtnButton
                                                            type="button"
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={() => this.revogar(c.uid)}
                                                        >
                                                            Revogar
                                                        </BtnButton>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="card mb-4">
                    <div className="card-body">
                        <h2 className="h5 mb-1">Atividade recente</h2>
                        <p className="text-muted">Ferramenta, resultado e duração. O conteúdo da chamada não é guardado.</p>
                        <div className="table-responsive">
                            <table className="table table-sm mb-0">
                                <thead>
                                    <tr>
                                        <th>Quando</th>
                                        <th>Ferramenta</th>
                                        <th>Resultado</th>
                                        <th>Duração</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.atividade.length === 0 ? (
                                        <tr>
                                            <td colSpan={4} className="text-muted">Nenhuma chamada ainda.</td>
                                        </tr>
                                    ) : (
                                        this.state.atividade.map((a, i) => (
                                            <tr key={i}>
                                                <td>{quando(a.dhCadastro)}</td>
                                                <td>{a.cdFerramenta || a.cdMetodo || "—"}</td>
                                                <td>{a.cdResultado}</td>
                                                <td>{a.nrDuracaoMs} ms</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
